<template>
  <div>
    <div class="top-tabs">
      <ul class="submenu">
        <li v-for="tab in localTabs" :key="tab.name" :class="['submenu-item', { active: tab.name === activeTab.name }]">
          <a href="#" @click="setActiveTab(tab)">
            {{ $tr(`responses.tabs.${tab.name === 'test-specprocess' ? 'test' : tab.name}.name`) }}
            <span v-if="comments.length && tab.name === 'comments'" class="count">
              {{ comments.length }}
            </span>
          </a>
        </li>
      </ul>
    </div>

    <tab-resume-default v-if="activeTab.name === 'resume-default'" :response="response" />

    <template v-if="isIos || isSafari">
      <tab-application v-if="activeTab.name === 'application'" :records="tabApplication" />

      <tab-answers-safari
        v-if="activeTab.name === 'answers'"
        :questions="questions"
        :response-id="response.id"
        @set_active_answer="$emit('set-active-answer', $event)"
      />
    </template>

    <template v-else>
      <tab-application v-if="activeTab.name === 'application'" :records="tabApplication" />

      <tab-answers
        v-if="activeTab.name === 'answers'"
        :questions="questions"
        :response-id="response.id"
        @set_active_answer="$emit('set-active-answer', $event)"
      />
    </template>

    <tab-competences v-if="activeTab.name === 'competences'" :response-id="response.id" />

    <tab-comments v-if="activeTab.name === 'comments'" :comments="comments" :response-id="response.id" />

    <tab-integration v-if="activeTab.name === 'integration'" />

    <vcv-tab-history v-if="activeTab.name === 'history'" />

    <tab-talentq v-if="activeTab.name === 'talentq'" />

    <!-- techlab start -->
    <tab-additional v-if="activeTab.name === 'additional'" :response-id="response.id" />
    <!-- techlab end -->

    <process-response-tab-test
      v-if="activeTab.name === 'test' || activeTab.name === 'test-specprocess'"
      :response="response"
      :response-id="response.id"
    />

    <process-response-tab-resume v-if="activeTab.name === 'resume'" :response="response" />

    <process-response-tab-team v-if="activeTab.name === 'team'" :response="response" />

    <process-response-tab-questionnaire v-if="activeTab.name === 'questionnaire'" :response="response" />

    <process-response-tab-presentation v-if="activeTab.name === 'presentation'" :response="response" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import TabAdditional from './tabs/TabAdditional';
import tabApplication from './tabs/tabApplication';
import TabAnswers from './tabs/TabAnswers';
import TabAnswersSafari from './tabs/TabAnswersSafari';
import TabComments from './tabs/TabComments';
import TabCompetences from './tabs/TabCompetences';
// import TabHistory from './tabs/TabHistory';
import TabResumeDefault from './tabs/TabResume';
import TabTalentq from '@/components/response/tabs/tab-talentq';
import TabIntegration from './tabs/TabIntegration';
import VcvTabHistory from './tabs/VcvTabHistory.vue';

import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import PROCESS_NAMES from '@/process/names';

export default {
  name: 'ResponseSceneTabs',

  components: {
    TabTalentq,
    TabIntegration,
    tabApplication,
    TabAnswers,
    TabAnswersSafari,
    TabComments,
    // TabHistory,
    TabCompetences,
    TabResumeDefault,
    TabAdditional,
    VcvTabHistory
  },

  mixins: [SafariBrowserDetector],

  props: {
    response: {
      type: Object,
      default: null
    },

    voicebot: {
      type: Object,
      default: null
    },

    questions: {
      type: Array,
      default: () => []
    },

    comments: {
      type: Array,
      default: () => []
    },

    history: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState('integrations', ['attribute_values']),

    ...mapGetters('situation/response', ['tabsAvailable']),

    ...mapGetters('process', ['getProcessName']),

    activeTab() {
      return this.$store.getters['response/tabs/activeTab'];
    },

    tabTest() {
      return this.response.test ? this.response.test.result : false;
    },

    tabIntegration() {
      return this.attribute_values && this.attribute_values.length > 0 ? this.attribute_values : false;
    },

    tabAnswers() {
      return this.response.questions.length > 0;
    },

    tabResume() {
      return this.response.properties.length > 0;
    },

    tabTalentq() {
      return this.response.talentq;
    },

    tabApplication() {
      return this.response.survey;
    },

    localTabs() {
      return this.tabsAvailable.filter(tab => {
        return (
          !(tab.name === 'application' && !this.tabApplication) &&
          !(tab.name === 'test' && !this.tabTest) &&
          !(tab.name === 'integration' && !this.tabIntegration) &&
          !(tab.name === 'answers' && !this.tabAnswers) &&
          !(tab.name === 'resume-default' && !this.tabResume) &&
          !(tab.name === 'talentq' && !this.tabTalentq)
        );
      });
    }
  },

  async created() {
    // start of techlab
    if (this.getProcessName === PROCESS_NAMES.SPORTMASTER) {
      this.ADD_TAB_AVAILABLE('additional');
    }
    if (this.getProcessName === PROCESS_NAMES.OBI) {
      this.REMOVE_TAB_AVAILABLE('application');
    }
    // end of techlab

    this.setActiveTab(this.localTabs[0]);

    let params = { filter: { response_id: this.response.id } };

    await this.fetchAttributeValues(params);
  },

  beforeDestroy() {
    this.CLEAR_ATTRIBUTE_VALUES();
  },

  methods: {
    ...mapMutations('situation/response', ['ADD_TAB_AVAILABLE', 'REMOVE_TAB_AVAILABLE']),

    ...mapMutations('integrations', ['CLEAR_ATTRIBUTE_VALUES']),

    ...mapActions('integrations', ['fetchAttributeValues']),

    setActiveTab(tab) {
      this.$store.dispatch('response/tabs/setActiveTab', tab);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/components/response/Tabs.scss';

.hideTab {
  display: none;
}

.top-tabs {
  margin-bottom: 30px;
}
</style>
